import { UseQueryOptions } from '@tanstack/react-query';

import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';
import { ContactColumn } from 'models/types';

import QueryKeys from './keys';

type Params = {
    recordTypes?: string[];
    reactQueryOptions?: UseQueryOptions<ContactColumn[], Error>;
};

const useContactEventColumnsMetadataExtended = ({ recordTypes, reactQueryOptions }: Params = {}) => {
    const axiosOptions = recordTypes?.length ? { params: { recordType: recordTypes.join(',') } } : undefined;
    return useQuery(
        QueryKeys.CONTACT_EVENT_COLUMNS_METADATA_EXTENDED(recordTypes),
        CuredApiPaths.CUSTOMER_SUPPORT_CONTACT_EVENT_COLUMNS,
        reactQueryOptions,
        axiosOptions
    );
};

export default useContactEventColumnsMetadataExtended;
